// Global alert/confirm event bus — แทน window.alert/window.confirm ด้วย MUI Dialog ที่ดีไซน์เดียวกับ
// GlobalErrorDialog (ดู globalError.js สำหรับ pattern เดียวกันฝั่ง error) ให้ non-React module เรียกได้
// โดยไม่ต้องผ่าน props/redux — GlobalAlertDialog/GlobalConfirmDialog (mount ที่ root) เป็นคนฟัง event นี้

const alertListeners = new Set();
const confirmListeners = new Set();

// showAlert = fire-and-forget เหมือน window.alert() เดิม (โค้ดหลังบรรทัดที่เรียกยังรันต่อทันที ไม่รอ user
// กดปิด dialog) — status: HTTP status code ถ้ามี (มาจาก error.response.status ที่จุดเรียกซึ่งมี error
// object อยู่แล้ว) ทำให้ badge ขึ้นสีแดง+เลข code, ไม่ส่งมา = ถือเป็นข้อความสำเร็จ badge เขียว ✓
export const showAlert = (message, { status = null } = {}) => {
  if (!message) return;
  alertListeners.forEach((cb) => cb(message, status));
};

export const subscribeAlert = (cb) => {
  alertListeners.add(cb);
  return () => alertListeners.delete(cb);
};

// confirmAsync คืน Promise<boolean> แทน window.confirm() ที่ return boolean แบบ synchronous ตรงๆ ไม่ได้
// (dialog เปิด/ปิดแบบ async) — ต้อง await ที่จุดเรียกแทน
export const confirmAsync = (message) =>
  new Promise((resolve) => {
    confirmListeners.forEach((cb) => cb(message, resolve));
  });

export const subscribeConfirm = (cb) => {
  confirmListeners.add(cb);
  return () => confirmListeners.delete(cb);
};
